const publicPages = ['/redeem-invite', '/redeem-invite/'];
const isPublicPage = publicPages.includes(window.location.pathname);

export default isPublicPage;
